import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const gqlQuery = gql`
  query Rdc($id: ID!) {
    rdc(id: $id) {
      id
      transactionId
      holds {
        amount {
          ...money
        }
        startDate
        endDate
        isActive
      }
      accountId
      rdcStatus {
        status
        copy
      }
      value {
        ...money
      }
      submittedOn
      confirmationNumber
      checkImages {
        title
        url
      }
      checkImageUrls
      accountLink {
        id
        type
        product
        status
        institution {
          name
        }
        name
        nickname
        iconUrl
        accountNumberLast4
      }
    }
  }
  ${money}
`;

export default gqlQuery;
